import { type StateUiLoading } from '~shared/reducers/ui/loading';
import { type ReduxStateShared } from '~shared/types';

const getLoading: (state: ReduxStateShared) => StateUiLoading = (state) => state.ui.loading;

export default getLoading;
